import { analytics_methods } from "../../utils/analytics_methods";

function triggerEvent() {

    const schema = {
        event: "string",
        event_type: "string",
        activity_id: "string",
        activity_name: "string",
        activity_nid: "string",  
        activity_type: "string", 
        activity_price: "number",
        country: "string", 
        origin: "string",
        lang_id: "string",
        page_type: "string",
        checkout_step: "string",
    }
    
    const COMMISSION_PERCENTAGE = 0.225;
    
    const data = {
        event: "page_identifier",
        event_type: "page_view",
        activity_id: window?.analytics_buendia?.activity_id || null,
        activity_name: window?.analytics_buendia?.activity_name || null,
        activity_nid: window?.analytics_buendia?.activity_nid || null,
        activity_type: window?.analytics_buendia?.activity_type || null,
        activity_price: window?.analytics_buendia?.value_without_commission * COMMISSION_PERCENTAGE || 0,
        country: window?.analytics_buendia?.country || null,
        origin: window?.analytics_buendia?.origin || null,
        lang_id: window?.analytics_buendia?.lang_id || null,
        page_type: window?.analytics_buendia?.page_type || null,
        checkout_step: window?.analytics_buendia?.checkout_step || ""
    }
    
    analytics_methods.sendToDataLayer(data, schema)
}

export const page_identifier_checkout = {
    triggerEvent
}